const useFormattingUtils = () => {
  function formatToDecimals(value: number): number {
    return parseFloat(value.toFixed(2));
  }

  function getTodayDateString(): string {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(today.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  return {
    formatToDecimals,
    getTodayDateString
  }
}

export default useFormattingUtils;